module.exports = __webpack_public_path__ + "static/media/akm.1895a719.png";